import SelectorButton from './SelectorButton.vue';

export default SelectorButton;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/calendar/components/selector/components/button/index.ts